enum ClickType {
  left,
  middle,
  right,
}

export default ClickType;
